import { render, staticRenderFns } from "./SearchPost.vue?vue&type=template&id=38d2ed25&"
import script from "./SearchPost.vue?vue&type=script&lang=js&"
export * from "./SearchPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports